import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import Input from 'antd/lib/input';
import Select from 'antd/lib/select';
import DatePicker from 'antd/lib/date-picker';
import Button from 'antd/lib/button';
import { ResponsiveTable } from '../../../common/components/data-display';
import Table from 'antd/lib/table';
import translate from 'react-i18next/dist/commonjs/translate';
import { currencyFormatter, formatDateTime } from '../../../common/utils/helpers';
import { transactionTypes } from '../../../common/enums/transactionTypes';
import { Link } from 'react-router';
import Slider from 'antd/lib/slider';

const { Column } = Table;
const { RangePicker } = DatePicker;
const { Option } = Select;

@translate()
export default class Transactions extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    transactions: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onSubmitFilter: PropTypes.func.isRequired,
  };
  state = {
    filter: {
      transactionId: "",
      AccountFrom: "",
      AccountTo: "",
      Amount: [],
      Type: "",
      TransactionDateAt: [],
      LoanNumber: "",
      InvestmentNumber: "",
      VS: ""
    }
  }
    onChange(value, key) {
      const filter = this.state.filter;
      filter[key] = value;
      this.setState({
        ...this.state,
        filter
      });
    }

    componentDidMount(){
      this.setState({
        filter: this.props.filter
      });
      console.log("transactions mounting")
      console.log(this.state.filter)
    }

    componentDidUpdate(prevProps, prevState){
      console.log("component updated")
      if (prevState.filter !== this.state.filter){
        console.log(this.state.filter)
      }

    }

    handleSubmit = () => {
      this.props.pagination.current = 1
      this.props.onSubmitFilter(this.state.filter);
    }

    handleTableChange = (pagination) => {
      console.log("table change")
      console.log(this.state.filter)
      this.props.onTableChange(pagination, this.state.filter)
    }

    render() {
      const {
        t,
        transactions,
        pagination,
        onTableChange,
      } = this.props;

      const {
        filter
      } =this.state;

      return (
        <div>
          <Row className="filters">
            <Col xs={12} md={2}>
              <div className="filter-search">
                <Input
                  placeholder={t('Id transakcie')}
                  value={filter.transactionId}
                  onChange={(e) => this.onChange(e.target.value, "transactionId")}
                  onPressEnter={this.handleSubmit}
                />
              </div>
            </Col>
            <Col xs={12} md={1}>
              <div className="filter-search">
                <Input
                  placeholder={t('Kredit')}
                  value={filter.AccountFrom}
                  onChange={(e) => this.onChange(e.target.value, "AccountFrom")}
                  onPressEnter={this.handleSubmit}
                />
              </div>
            </Col>
            <Col xs={12} md={1}>
              <div className="filter-search">
                <Input
                  placeholder={t('Debet')}
                  value={filter.AccountTo}
                  onChange={(e) => this.onChange(e.target.value, "AccountTo")}
                  onPressEnter={this.handleSubmit}
                />
              </div>
            </Col>
            <Col xs={12} style={{"maxWidth": "20%"}}>
              <Select
                placeholder={t('Typ transakcie')}
                key="Type"
                value={filter.Type}
                onChange={(value) => this.onChange(value, "Type")}
                >
                <Option key="" value="">
                  {t('Všetky typy')}
                </Option>
                {Object.entries(transactionTypes).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col xs={12} md={2}>
              <RangePicker
                format="DD.MM.YYYY"
                key="TransactionDateAt"
                value={filter.TransactionDateAt}
                onChange={
                  ([dateFrom, dateTo]) => {
                    this.onChange([dateFrom, dateTo], "TransactionDateAt");
                  }
                }
              />
            </Col>
            <Col xs={12} md={1}>
              <div className="filter-search">
                <Input
                  placeholder={t('Pôžička')}
                  value={filter.LoanNumber}
                  onChange={(e) => this.onChange(e.target.value, "LoanNumber")}
                  onPressEnter={this.handleSubmit}
                />
              </div>
            </Col>
            <Col xs={12} md={1}>
              <div className="filter-search">
                <Input
                  placeholder={t('Investícia')}
                  value={filter.InvestmentNumber}
                  onChange={(e) => this.onChange(e.target.value, "InvestmentNumber")}
                  onPressEnter={this.handleSubmit}
                />
              </div>
            </Col>
            <Col xs={12} md={1}>
              <div className="filter-search">
                <Input
                  placeholder={t('VS')}
                  value={filter.VS}
                  onChange={(e) => this.onChange(e.target.value, "VS")}
                  onPressEnter={this.handleSubmit}
                />
              </div>
            </Col>
            <Col>
              <Button size="small" onClick={this.handleSubmit} type="primary" icon="search" />
              &nbsp;
              <Button size="small" onClick={() => {
                
                this.setState({
                  filter: {
                    transactionId: "",
                    AccountFrom: "",
                    AccountTo: "",
                    Amount: "",
                    Type: "",
                    TransactionDateAt: [],
                    LoanNumber: "",
                    InvestmentNumber: "",
                    VS: ""
                  }  
                });
                
              }} icon="close" />
            </Col>
          </Row>
          <Row className="filters padded">
            <Col xs={12} sm={12}>
              <div>
                <Slider
                    range={true}
                    tipFormatter={currencyFormatter}
                    onChange={(value) => {
                      this.onChange(value, "Amount")
                    }}
                    defaultValue={[0,50000]}
                    min={0}
                    max={50000}
                    step={100}
                    marks={{
                      [0]: <span>{currencyFormatter(0)}</span>,
                      [50000]: <span>{currencyFormatter(50000)}</span>,
                    }}
                  />
              </div>
            </Col>
          </Row>

          <ResponsiveTable
            dataSource={transactions}
            rowKey={transaction => transaction.id}
            pagination={pagination}
            onChange={this.handleTableChange}
          >
            <Column
              title={t('ID Transakcie')}
              dataIndex="id"
              key="id"
            />
            <Column
              title={t('Z účtu')}
              dataIndex="AccountFrom"
              key="AccountFrom"
              render={AccountFrom => <Link to={`/admin/accounts/${AccountFrom.id}/profile`}>{`${AccountFrom.nameFirst} ${AccountFrom.nameLast}`}</Link>}
          />

            <Column
              title={t('Na účet')}
              dataIndex="AccountTo"
              key="AccountTo"
              render={AccountTo => <Link to={`/admin/accounts/${AccountTo.id}/profile`}>{`${AccountTo.nameFirst} ${AccountTo.nameLast}`}</Link>}
            />
            <Column
              title={t('Suma')}
              dataIndex="Amount"
              key="Amount"
              render={amount => currencyFormatter(amount)}
            />
            <Column
              title={t('Typ transakcie')}
              dataIndex="Type"
              key="Type"
              render={Type => t(transactionTypes[Type])}
            />
            <Column
              title={t('Dátum transakcie')}
              dataIndex="TransactionDateAt"
              key="TransactionDateAt"
              render={TransactionDateAt => formatDateTime(TransactionDateAt)}
            />
            <Column
              title={t('Pôžička')}
              dataIndex="Loan"
              key="Loan"
              render={loan => ((loan.id) ? <Link to={`/admin/loans/${loan.id}`}>{`${loan.LoanNumber}`}</Link> : '')}
            />
            <Column
              title={t('Investícia')}
              dataIndex="Investment"
              key="Investment"
              render={investment => ((investment.id) ? <Link to={`/admin/allocations/${investment.AllocationId}`}>{`${investment.InvestmentNumber}`}</Link> : '')}
            />
            <Column
              title={t('Banková transakcia')}
              dataIndex="Payment"
              key="Payment"
              render={payment => ((payment.id) ? <Link to={`/admin/payments/${payment.id}`}>{`${payment.VS}`}</Link> : '')}
            />

          </ResponsiveTable>

          <Link to={`admin/report/reportJob`}  >
          <Button>Rekonciliácia</Button>
        </Link>


        </div>
      );
    }
}



// WEBPACK FOOTER //
// ./src/features/transactions/components/Transactions.js